import React from 'react'
import './vehiculo-card.css';

import { Avatar } from 'primereact/avatar';

const VehiculoCard = React.memo(({ v, seleccionado, onClick }) => {
  return (
    <button
      type="button"
      className={`btn-vehiculo ${seleccionado ? "active" : ""}`}
      onClick={onClick}
    >
      <Avatar 
        icon="pi pi-car" 
        size="large" 
        shape="circle" 
        className="avatar-vehiculo"
      />

      <div>
        <span className="font-bold">{v.patente}</span>
        <span className="block text-500">{v.modelo.toUpperCase()}</span>
      </div>
      
    </button>
  );
});

export default VehiculoCard;